import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon } from 'lucide-react';
const packs = [{
  name: 'PACK AUTORES SELECTOS',
  desc: 'Las mejores obras de autores de renombre mundial.',
  color: 'text-blue-500',
  bg: 'bg-blue-50'
}, {
  name: 'PACK BIENES RAÍCES',
  desc: 'Domina la inversión inmobiliaria y la gestión de propiedades.',
  color: 'text-emerald-500',
  bg: 'bg-emerald-50'
}, {
  name: 'PACK ÉXITO, LIDERAZGO Y DESARROLLO PERSONAL',
  desc: 'Herramientas para liderar, crecer y alcanzar tu máximo potencial.',
  color: 'text-amber-500',
  bg: 'bg-amber-50'
}, {
  name: 'PACK FINANZAS, MARKETING Y VENTAS',
  desc: 'Estrategias financieras, de marketing y técnicas de ventas comprobadas.',
  color: 'text-green-600',
  bg: 'bg-green-50'
}, {
  name: 'PACK FOTOGRAFÍA E IMAGEN',
  desc: 'Aprende fotografía profesional y manejo de imagen personal.',
  color: 'text-purple-500',
  bg: 'bg-purple-50'
}, {
  name: 'PACK NUTRICIÓN, FITNESS Y SALUD',
  desc: 'Guías completas de bienestar físico, nutrición y vida saludable.',
  color: 'text-rose-500',
  bg: 'bg-rose-50'
}, {
  name: 'PACK PARA DUMMIES',
  desc: 'Temas complejos explicados de forma simple para principiantes.',
  color: 'text-yellow-500',
  bg: 'bg-yellow-50'
}, {
  name: 'PACK OTRAS TEMÁTICAS',
  desc: 'Una variedad de temas adicionales para expandir tus horizontes.',
  color: 'text-slate-600',
  bg: 'bg-slate-50'
}, {
  name: 'PACK DE DEFENSA PERSONAL',
  desc: 'Técnicas y estrategias de autodefensa y seguridad personal.',
  color: 'text-red-500',
  bg: 'bg-red-50'
}, {
  name: 'PACK SEDUCCIÓN, CONQUISTA Y ATRACCIÓN',
  desc: 'El arte de las relaciones, la comunicación y la atracción interpersonal.',
  color: 'text-pink-500',
  bg: 'bg-pink-50'
}];
export function DetailedPacks() {
  return <section className="py-24 bg-gray-50 border-y border-gray-200" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-navy mb-4" data-id="element-43">
            Explora Nuestras Colecciones Exclusivas
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-44">
            Tu biblioteca está organizada en carpetas especializadas para una
            navegación fácil.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-45">
          {packs.map((pack, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-46">
              <div className={`p-3 rounded-lg ${pack.bg} ${pack.color} shrink-0`} data-id="element-47">
                <BookIcon size={24} data-id="element-48" />
              </div>
              <div data-id="element-49">
                <h3 className="font-bold text-gray-900 text-sm mb-1" data-id="element-50">
                  {pack.name}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed" data-id="element-51">
                  {pack.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}